import * as selectors from '../selectors';
import type { CreditScore, MongoDealerCreditTier } from '@makemydeal/dr-platform-types';
import { FINANCE } from '@makemydeal/dr-platform-types';
import { getAverageCreditScore } from '@makemydeal/dr-payment-utils';
import type { CreditTierScoreHighLow } from '../types/commonTypes';
import { isEmpty } from './common';

/**
 * Builds a CreditScore object from the current state
 * Calculates credit score based on selected credit tier or manual override
 *
 * @param state - Redux state containing credit tier and score information
 * @returns CreditScore object with low, high, description, and target score
 */
export const buildCreditScore = (state: any): CreditScore => {
    const creditTierId = selectors.getSelectedCreditTierIdByType(state, FINANCE);
    const creditTier = selectors.getCreditTierById(state, creditTierId) || null;
    const creditRange = creditTier && !isEmpty(creditTier) ? creditTier.score : ({} as CreditTierScoreHighLow);
    const manualCreditScore = selectors.getManualCreditScore(state);
    const creditScore =
        manualCreditScore ||
        getAverageCreditScore({ lowScore: creditRange.low, highScore: creditRange.high } as MongoDealerCreditTier) ||
        0;

    return {
        low: creditRange.low || 0,
        high: creditRange.high || 0,
        description: creditTier && !isEmpty(creditTier) ? creditTier.name : 'N/A', // cannot be empty
        isManualCreditScore: !!manualCreditScore,
        creditTierTargetScore: creditScore
    };
};
